const titleCase = (str) => {
  if (str) {
    return str
      .toLowerCase()
      .split(' ')
      .map(s => s.charAt(0).toUpperCase() + s.substring(1))
      .join(' ');
  }
  return '';
};

const sentenceCase = (str) => {
  if (str) {
    const newString = str.toLowerCase().replace(/(^\s*\w|[.!?]\s*\w)/g, c => c.toUpperCase());
    return newString;
  }
  return '';
};

const formatPrice = (amt, prefix = '', decCount = 0, decimal = '.', thousands = ',') => {
  try {
    if (amt) {
      let decimalCount = Math.abs(decCount);
      decimalCount = Number.isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amt < 0 ? '-' : '';
      let amount;
      const i = parseInt(
        (amount = Math.abs(Number(amt) || 0).toFixed(decimalCount)),
        10,
      ).toString();
      const j = i.length > 3 ? i.length % 3 : 0;

      return (
        prefix
        + negativeSign
        + (j ? i.substr(0, j) + thousands : '')
        + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`)
        + (decimalCount
          ? decimal
            + Math.abs(amount - i)
              .toFixed(decimalCount)
              .slice(2)
          : '')
      );
    }
    return '';
  } catch (e) {
    return '';
  }
};

const numbersOnly = (string) => {
  try {
    return string.replace(/\D/g, '');
  } catch (e) {
    return '';
  }
};

const stringSeparator = (str, separator = '·') => {
  try {
    if (str) {
      return `${separator} ${str}`;
    }
    return '';
  } catch (e) {
    return str;
  }
};

const truncateString = (str, len = 30) => {
  try {
    if (str && len && str.length > len) {
      return `${str.substring(0, len)}...`;
    }
    return str;
  } catch (e) {
    return str;
  }
};

const percentage = (value, decimals) => {
  if (value === null || value === undefined) {
    return '-';
  }
  const baseWhole = !value ? 0 : value * 100;
  const baseExponent = 10 ** (!decimals ? 0 : decimals);
  return `${Math.round(baseWhole * baseExponent) / baseExponent}%`;
};

const address = (addressObj, fullAddress = false) => {
  if (addressObj !== null && addressObj.street && addressObj.suburb && addressObj.postCode) {
    const shortAddress = titleCase(addressObj.unitNumber
      ? `${addressObj.unitNumber.toUpperCase()}/${addressObj.streetNumber.toUpperCase()} ${addressObj.street}, ${addressObj.suburb}`
      : `${addressObj.streetNumber.toUpperCase() ? addressObj.streetNumber : ''} ${addressObj.street}, ${addressObj.suburb}`);

    // If fullAddress also return state and postcode
    return fullAddress ? `${shortAddress}, ${addressObj.state.toUpperCase()} ${addressObj.postCode.toUpperCase()}` : shortAddress;
  }

  return null;
};

const leadStatus = (leadAgentMappingObj) => {
  try {
    if (leadAgentMappingObj.leadAgentLeadStateId == 2) {
      return leadAgentMappingObj.leadAgentLeadState;
    }
    if (leadAgentMappingObj.leadAgentLeadStateId == 1) {
      if (leadAgentMappingObj.leadAgentLeadStageId == 6) {
        return 'Won';
      }
      return leadAgentMappingObj.leadAgentLeadState;
    }
  } catch (e) {
    return leadAgentMappingObj.leadAgentLeadState;
  }
};

const placeholderWhenNoData = (data) => {
  if (data === undefined || data === null) {
    return 'n/a';
  }
  return data;
};

const formatNumber = num => num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

export {
  titleCase,
  sentenceCase,
  formatPrice,
  numbersOnly,
  stringSeparator,
  truncateString,
  percentage,
  address,
  leadStatus,
  placeholderWhenNoData,
  formatNumber,
};
